<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <!--<img src="~@/assets/login-img1.png" class="bg-image" />-->
    <div class="container">
      <div class="top"></div>

      <div class="div-content">
        <!--<div class="mask"></div>-->
        <!--<img src="~@/assets/login-img0.svg" class="login-image-left" />-->
        <div class="login-image-left"></div>
        <route-view></route-view>
      </div>

      <div class="footer">
        <!-- <div class="links">
          <a href="http://120.78.231.31:8080/ics/cm/cm0501?" target="_blank">帮助</a>
          <a href="http://120.78.231.31:8080/ics/cm/cm0501?" target="_blank">隐私</a>
          <a href="https://opensource.org/licenses" target="_blank">条款</a>
        </div>
        <div class="copyright">
          Copyright &copy; 2020
          <a
            href="http://120.78.231.31:8080/ics/cm/cm0501?"
            target="_blank"
          >楷码信息</a> 出品
        </div>-->
      </div>
    </div>

  </div>
</template>

<script>
import RouteView from '@/components/layouts/RouteView'
import { mixinDevice } from '@/utils/mixin.js'

export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data() {
    return {}
  },
  mounted() {
    document.body.classList.add('userLayout')

    // ウインドウズのサイズにより、適当にズームする
    if (zoomLogin) {
      zoomLogin()
    }

    const animation = lottie.loadAnimation({
      container: document.querySelector('.login-image-left'),
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: `//${window.location.host}/svg/lottiefiles/login-img.json`,
    })

    var interval = setInterval(() => {
      if (document.querySelector('.login-image-left > svg')) {
        clearInterval(interval)
        document.querySelector('.login-image-left > svg').attributes['preserveAspectRatio'].value = 'none meet'
        document.querySelector('.login-image-left').classList.add('show')

        setTimeout(() => {
          animation.play()
        }, 600)
      }
    }, 1)

    // class MorphingBG {
    //   constructor(el) {
    //     this.DOM = {}
    //     this.DOM.el = el
    //     this.DOM.paths = Array.from(this.DOM.el ? this.DOM.el.querySelectorAll('path') : [])
    //     this.animate()
    //   }
    //   animate() {
    //     this.DOM.paths.forEach(path => {
    //       setTimeout(() => {
    //         anime({
    //           targets: path,
    //           duration: anime.random(8000, 10000),
    //           easing: [0.5, 0, 0.5, 1],
    //           d: path.getAttribute('pathdata:id'),
    //           loop: true,
    //           direction: 'alternate'
    //         })
    //       }, anime.random(0, 1000))
    //     })
    //   }
    // }

    // new MorphingBG(document.querySelector('svg.scene'))
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  },
  methods: {},
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;
  background-size: 100%;
  // background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 10%, transparent 0),
  //   linear-gradient(180deg, rgba(0, 0, 0, 0.3) 20%, transparent 0),
  //   linear-gradient(180deg, rgba(0, 0, 0, 0.3) 30%, transparent 0),
  //   linear-gradient(180deg, rgba(0, 0, 0, 0.3) 40%, transparent 0),
  //   linear-gradient(180deg, rgba(0, 0, 0, 0.3) 50%, transparent 0),
  //   linear-gradient(180deg, rgba(0, 0, 0, 0.3) 60%, transparent 0),
  //   linear-gradient(180deg, rgba(0, 0, 0, 0.3) 70%, transparent 0),
  //   linear-gradient(180deg, rgba(0, 0, 0, 0.3) 80%, transparent 0),
  //   linear-gradient(180deg, rgba(0, 0, 0, 0.3) 90%, transparent 0);
  //animation: run-in 1s both ease-out;

  @keyframes run-in {
    0% {
      opacity: 0.2;
    }

    100% {
      opacity: 1;
    }
  }

  &.mobile {
    .container {
      .div-content {
        .login-image-left {
          display: none;
        }

        .main {
          width: 100%;
          //height: 100%;
          left: 0;
          right: 0;
          filter: none;
          border-radius: 0;
          box-shadow: none;

          /deep/ p.copyright {
            position: fixed;
          }
        }
      }
    }
  }

  .container {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    // padding: 110px 0 144px;
    // background-image: url(~@/assets/login-bg1.png);
    // background-repeat: no-repeat;

    a {
      text-decoration: none;
    }

    .top {
      text-align: center;

      .header {
        height: 44px;
        line-height: 44px;

        .badge {
          position: absolute;
          display: inline-block;
          line-height: 1;
          vertical-align: middle;
          margin-left: -12px;
          margin-top: -10px;
          opacity: 0.9;
        }

        .logo {
          height: 44px;
          vertical-align: top;
          margin-right: 16px;
          border-style: none;
        }

        .title {
          font-size: 33px;
          color: rgba(0, 0, 0, 0.85);
          font-weight: 600;
          position: relative;
          top: 2px;
        }
      }
      .desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 40px;
      }
    }

    .main {
      min-width: 260px;
      width: 400px;
      height: 542px;
      position: absolute;
      z-index: 99;
      background: white;
      padding: 0 50px;
      box-shadow: none;
      padding-top: 45px;
      //filter: drop-shadow(0px 0px 100vh black);
      box-shadow: 15px 15px 50vh rgba(158, 167, 179, 40%), 30px 30px 60px -30px rgba(188, 182, 188, 100%);
      //box-shadow: 15px 15px 70px rgba(158, 167, 179, 40%);
      top: -10px;
      bottom: 0;
      margin: auto;
      //background-image: url(~@/assets/bg_1.svg);
      //background-size: 50%;
      //background-repeat: no-repeat;
      //background-position-x: right;
    }

    //.login-image-left::after {
    //  content: '';
    //  position: fixed;
    //  display: block;
    //  width: 200%;
    //  height: 200%;
    //  background: rgb(0 0 0 / 7%);
    //  left: -50%;
    //  top: -50%;
    //  z-index: -1;
    //}

    .footer {
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 0 16px;
      margin: 48px 0 24px;
      text-align: center;

      .links {
        margin-bottom: 8px;
        font-size: 14px;
        a {
          color: rgba(0, 0, 0, 0.45);
          transition: all 0.3s;
          &:not(:last-child) {
            margin-right: 40px;
          }
        }
      }
      .copyright {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
      }
    }

    .div-content {
      position: absolute;
      width: 100%;
      //max-width: 1220px;
      //height: 580px;
      height: 100%;
      padding: 0px 0 0;
      background: transparent;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      /* margin-left: -195px; */
      /* margin-top: -230px; */
      // transition: all 0.6s;
      border-radius: 0px;
      z-index: 2;
      transform: scale(1);
      opacity: 1;
      // animation: scale-in 1s both ease-in-out;
      // filter: drop-shadow(0px 0px 15px #ddd);
      //box-shadow: 0 0 200px #000;
    }

    .div-content .main {
      transition: all 0.8s;
      // box-shadow: 15px 15px 20px 0px;
      // box-shadow: 10px 10px 20px 0px #6f6f6f;
      //border-top-right-radius: 10px;
      //border-bottom-right-radius: 10px;
      border-radius: 8px;
      display: inline-block;
      right: 11%;
    }

    .div-content .main:hover {
      // box-shadow: 10px 10px 20px 0px #6f6f6f;
    }
  }
}

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  z-index: 3;
  opacity: 0.1;
}

.bg-image {
  // background-image: url(~@/assets/login-bg1.png);
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
  filter: blur(0px);
  transform: scale(1);
  background-size: cover;
  background-position: top;
}

.login-image-left {
  width: 106%;
  height: 100%;
  //width: calc(100% - 10px);
  //width: calc(100% - 390px);
  display: inline-block;
  // transform: rotateY(180deg);
  position: absolute;
  // border-radius: 10px;
  //border-top-left-radius: 10px;
  //border-bottom-left-radius: 10px;
  transform: rotateY(180deg);
  //animation-delay: 0.8s;
  opacity: 0;
  filter: grayscale(1);

  &.show {
    animation: fade-in 1.2s both ease-out;
  }

  @keyframes fade-in {
    100% {
      opacity: 1;
      filter: grayscale(0);
    }
  }
}
</style>
